/**
 * Instagram Feed Fetcher
 * Fetches the latest 10 posts from Instagram Graph API and displays them
 */

// Configuration - Replace with your actual access token
const INSTAGRAM_ACCESS_TOKEN = 'IGAAUwZBF9zHY5BZAFE2TjZANZAG1UcGpoMEVnVDNDZA2hCdUdXa1o0Y1FIOFRVUVN5cFZACOG9lXzBwS3VBZAGl3dFZA6MGtTWU9Jb3NaaGpwVkRmdEd6Q1gxU29BR0U1N1l5dEhfMVVPYkowdUhDYWR0ME9GVF9YSW5ybFRXQk9CZAnBENAZDZD';
const API_ENDPOINT = `https://graph.instagram.com/me/media?fields=id,caption,media_url,media_type,permalink&access_token=${INSTAGRAM_ACCESS_TOKEN}&limit=250`;
const POSTS_LIMIT = 6;

/**
 * Fetches Instagram posts from the Graph API
 */
async function fetchInstagramPosts() {
    try {
        const response = await fetch(API_ENDPOINT);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        // Check for API errors
        if (data.error) {
            throw new Error(`Instagram API Error: ${data.error.message}`);
        }
        
        return data.data || [];
    } catch (error) {
        console.error('Error fetching Instagram posts:', error);
        throw error;
    }
}

/**
 * Updates image URLs in existing collage-grid items
 */
function displayInstagramPosts(posts) {
    // Get all images in collage-grid__item elements
    const gridItems = document.querySelectorAll('.collage-grid__item');
    
    if (gridItems.length === 0) {
        console.error('No collage-grid__item elements found');
        return;
    }
    
    // Filter posts to only include images (exclude videos/reels)
    const imagePosts = posts.filter(post => post.media_type === 'IMAGE' && post.media_url).slice(0, POSTS_LIMIT);
    
    if (imagePosts.length === 0) {
        console.warn('No image posts available to display');
        return;
    }
    
    // Update each grid item's image and link
    gridItems.forEach((item, index) => {
        if (index >= imagePosts.length) {
            return;
        }
        
        const post = imagePosts[index];
        const img = item.querySelector('img');
        let link = item.querySelector('a');
        
        // Update image URL
        if (img) {
            img.src = post.media_url;
            
            // Add link if it doesn't exist
            if (!link && post.permalink) {
                link = document.createElement('a');
                link.href = post.permalink;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                
                // Wrap image in link
                img.parentNode.insertBefore(link, img);
                link.appendChild(img);
            }
        }
        
        // Update link href if it exists
        if (link && post.permalink) {
            link.href = post.permalink;
        }
    });
}

/**
 * Initialize the Instagram feed
 */
async function initInstagramFeed() {
    // Check if access token is set
    if (INSTAGRAM_ACCESS_TOKEN === 'YOUR_ACCESS_TOKEN_HERE') {
        console.error('Please set your Instagram access token in instagram-feed.js');
        return;
    }
    
    try {
        const posts = await fetchInstagramPosts();
        displayInstagramPosts(posts);
    } catch (error) {
        console.error('Failed to initialize Instagram feed:', error);
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstagramFeed);
} else {
    // DOM is already ready
    initInstagramFeed();
}

